
import { getAllAreas, getBannerList } from './common';
import { getFaqList, getFaqDetail } from "./faq";
import { getArchivesList } from "./archives";
import { getDiscussTopicList, getDiscussDetail, getSelfTopicList, createTopic, getDiscussAnswerList, replyTopic } from "./discuss";
import { getVerifyCode, getFundAccount} from "./account";

export default class HttpService {
    //通用接口
    getAllAreas = getAllAreas;
    getBannerList = getBannerList;


    //获取常见问题
    getFaqList = getFaqList;
    getFaqDetail = getFaqDetail;

    //文库
    getArchivesList = getArchivesList;

    getDiscussTopicList = getDiscussTopicList;
    getDiscussDetail = getDiscussDetail;
    getSelfTopicList = getSelfTopicList;
    createTopic = createTopic;
    getDiscussAnswerList = getDiscussAnswerList;
    replyTopic = replyTopic;

    //账号
    getVerifyCode = getVerifyCode;
    getFundAccount = getFundAccount;
}